"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePinBorderRadiusStyles = void 0;
var _react = require("react");
var _cdsUtils = require("@cbhq/cds-utils");
var _borderRadius = require("../tokens/borderRadius");
const usePinBorderRadiusStyles = (pin, radius) => {
  return (0, _react.useMemo)(() => {
    if (!radius) return _cdsUtils.emptyObject;
    switch (pin) {
      case 'top':
        return {
          borderBottomRightRadius: _borderRadius.borderRadius[radius],
          borderBottomLeftRadius: _borderRadius.borderRadius[radius],
          borderTopRightRadius: 0,
          borderTopLeftRadius: 0,
          borderTopWidth: 0
        };
      case 'right':
        return {
          borderTopLeftRadius: _borderRadius.borderRadius[radius],
          borderBottomLeftRadius: _borderRadius.borderRadius[radius],
          borderBottomRightRadius: 0,
          borderTopRightRadius: 0,
          borderRightWidth: 0
        };
      case 'bottom':
        return {
          borderTopRightRadius: _borderRadius.borderRadius[radius],
          borderTopLeftRadius: _borderRadius.borderRadius[radius],
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          borderBottomWidth: 0
        };
      case 'left':
        return {
          borderTopRightRadius: _borderRadius.borderRadius[radius],
          borderBottomRightRadius: _borderRadius.borderRadius[radius],
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          borderLeftWidth: 0
        };
      default:
        return _cdsUtils.emptyObject;
    }
  }, [pin, radius]);
};
exports.usePinBorderRadiusStyles = usePinBorderRadiusStyles;